/**
 * This class describes a headers prototype.
 *
 * @class      HeadersPrototype (name)
 */
export default class HeadersPrototype extends Array {

    __collections__ = {}
    
    /**
     * 
     * @param {*} name 
     * @param  {...any} items 
     */
    constructor(name, ...items) {

        if (typeof name !== 'string') {
            super(name, ...items)
        } else {
            super(...items)
        }

        if (typeof name !== 'string') {
            
        } else {
            this.name = name
        }        
    }

    /**
     * 
     */
    everyIsNotValue = values => item => values.every(this.isNotValue(item.value))

    /**
     * 
     */
    isNotValue = value => item => item !== value

    /**
     * 
     */
    exclude(values = []) {
        return this.slice().filter(this.everyIsNotValue(values))
    }

    set(name, arr){
        this.__collections__[name] = arr
        return this
    }
    get(name){
        return this.__collections__[name]
    }
}
